"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationScheduledNurseSummaryDto = instanceOfOrientationScheduledNurseSummaryDto;
exports.OrientationScheduledNurseSummaryDtoFromJSON = OrientationScheduledNurseSummaryDtoFromJSON;
exports.OrientationScheduledNurseSummaryDtoFromJSONTyped = OrientationScheduledNurseSummaryDtoFromJSONTyped;
exports.OrientationScheduledNurseSummaryDtoToJSON = OrientationScheduledNurseSummaryDtoToJSON;
exports.OrientationScheduledNurseSummaryDtoToJSONTyped = OrientationScheduledNurseSummaryDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationScheduledNurseSummaryDto interface.
 */
function instanceOfOrientationScheduledNurseSummaryDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    if (!('scheduledDates' in value) || value['scheduledDates'] === undefined)
        return false;
    return true;
}
function OrientationScheduledNurseSummaryDtoFromJSON(json) {
    return OrientationScheduledNurseSummaryDtoFromJSONTyped(json, false);
}
function OrientationScheduledNurseSummaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'id': json['id'] == null ? undefined : json['id'],
        'avatar': json['avatar'],
        'scheduledDates': json['scheduledDates'],
    };
}
function OrientationScheduledNurseSummaryDtoToJSON(json) {
    return OrientationScheduledNurseSummaryDtoToJSONTyped(json, false);
}
function OrientationScheduledNurseSummaryDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'id': value['id'],
        'avatar': value['avatar'],
        'scheduledDates': value['scheduledDates'],
    };
}
//# sourceMappingURL=OrientationScheduledNurseSummaryDto.js.map